export default function capitalize(value: string | number | boolean): string {
  const arr = value.toString().toLowerCase().split("_").join(" ").split(" ");

  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
}